import { render } from "./AddReceptionStock.vue?vue&type=template&id=b30b1e10&ts=true"
import script from "./AddReceptionStock.vue?vue&type=script&lang=ts"
export * from "./AddReceptionStock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__